<template>
    <div class='login'>
        <div class="login-top-div">
                <img class="login-l-img" src="../assets/logo.png" style="margin-right: 3px;">
                <span>苏州科林利康医药科技有限公司</span>
            <!-- <a class="logo">苏州科林利康医药科技有限公司</a> -->
        </div>
        <div class="login-center">
            <!--左边图片-->
            <img class="login-l-img" src="../assets/login_bg.jpg">
            <!--右边登录-->
            <div class="login-r-div">
                <h1>登录</h1>
                <el-form ref="loginForm" :model="loginForm" :rules="loginRule">
                    <el-form-item label="账号" prop="email">
                        <el-input v-model.trim="loginForm.email" class="input"/>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="loginForm.password" class="input"/>
                    </el-form-item>
                    <el-form-item prop="code">
                        <el-input
                            v-model="loginForm.code"
                            auto-complete="off"
                            placeholder="验证码"
                            class="input"
                            style="width: 63%"
                            @keyup.enter.native="onLogin"
                        />
                        <div class="login-code">
                            <img :src="codeUrl" @click="getCode" class="login-code-img" />
                        </div>
                    </el-form-item>
                </el-form>
                <!-- <slide-verify :l="42" :r="10" :w="266" :h="110" slider-text="向右滑动" @success="onSuccess" @fail="onFail" @refresh="onRefresh"></slide-verify>
                <div style="text-align: center">{{ msg }}</div> -->
                <div style="margin-top: 20px">
                    <el-button @click="onLogin" class="login-bnt" type="primary">登录</el-button>
                </div>
            </div>
        </div>
        <p class="login-bottom-span">
            Copyright © 2022 苏州科林利康医药科技有限公司 版权所有<br>
            &nbsp;
            <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            >苏ICP备2024073443号-1</a
            >
        </p>
    </div>
</template>

<script>
    import {PostLogin, getCodeImg} from '../api/login'
    import md5 from "md5"
    import qs from 'qs'

    export default {
        name: "login",
        data() {
            return {
                loginForm: {
                    email: "",
                    password: "",
                    code: "",
                    uuid: "",
                },
                loginRule: {
                    email: [
                        {required: true, message: ' ', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: ' ', trigger: 'blur'}
                    ],
                    code: [
                        { required: true, trigger: "change", message: "验证码不能为空" },
                    ],
                },
                msg: '',
                codeUrl: "",
            }
        },
        created() {
            this.getCode();
        },
        methods: {
            getCode() {
                getCodeImg().then((res) => {
                    this.codeUrl = "data:image/gif;base64," + res.data.img;
                    this.loginForm.uuid = res.data.uuid;
                });
            },
            onLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        // if (this.msg === '') {
                        //     this.$message.error('请拖动滑块完成验证后登录');
                        //     return false;
                        // }
                        PostLogin(qs.stringify({
                            email: this.loginForm.email,
                            password: md5(this.loginForm.password),
                            code: this.loginForm.code,
                            uuid: this.loginForm.uuid,
                        })).then(res => {
                            if (res.status) {
                                sessionStorage.setItem('token', res.data.token);
                                sessionStorage.setItem('userName', res.data.userName);
                                sessionStorage.setItem('admin', res.data.admin);
                                sessionStorage.setItem('companyId', res.data.companyId);
                                this.$router.replace("/");
                            }
                        }).catch(err => {
                            this.$notify.error({
                                title: "错误",
                                message: err,
                            });
                            this.getCode();
                        })
                    } else {
                        this.$notify.error({
                            title: "错误",
                            message: "请填写正确信息",
                        });
                    }
                })
            },
            onSuccess() {
                this.msg = '验证成功';
            },
            onFail() {
                this.msg = '';
            },
            onRefresh() {
                this.msg = '';
            },
        }
    }
</script>

<style lang='less' scoped>


    .login {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        position: relative;
        background-color: #F5F8FA;
    }

    .login-top-div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #3ABEC4;
        position: absolute;
        top: 0;
        flex-direction: column;
        img {
            max-height: 8vh;
        }
        span {
            color: #333333;
            font-size: 22px;
        }

        // .logo {
        //     padding: 11px 30px;
        //     color: #3ABEC4;

            // &::before {
            //     content: " ";
            //     display: inline-block;
            //     width: 110px;
            //     height: 38px;
            //     background-image: url("../assets/logo.png");
            //     background-repeat: no-repeat;
            //     background-size: 110px 38px;
            //     margin-right: 5px;
            // }
        // }
    }

    .login-center {
        border-radius: 2px;
        background-color: beige;
        width: 760px;
        height: 540px;
        display: flex;
        overflow: hidden;

        .login-l-img {
            width: 50%;
        }

        .login-r-div {
            flex: 1;
            background-color: white;
            display: flex;
            flex-direction: column;
            align-items: center;

            .input {
                // width: 270px;
            }

            .login-footer {
                display: flex;
                justify-content: space-around;
                width: 100%;
                margin-top: 35px;

                .login-language {
                    cursor: pointer;
                }
            }
        }

        .forget-pwd {
            font-size: 14px;
            margin-left: 10px;
            cursor: pointer;
        }

        .auth-code {
            position: relative;

            .verify {
                position: absolute;
                margin: auto;
                font-size: 12px;
                right: 5px;
                bottom: 0;
                cursor: pointer;
            }
        }

        .login-bnt {
            width: 110px;
        }
    }

    .login-bottom-span {
        position: absolute;
        bottom: 10px;
    }
    .login-code {
        width: 33%;
        height: 40px;
        float: right;
        img {
            cursor: pointer;
            vertical-align: middle;
        }
    }
    .login-code-img {
        height: 40px;
    }
</style>
